import { config } from '../../config';
import { HttpServices } from '../../Helper';

export const GetCampaignPerformanceByProperty = async (body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/Campaigns/GetCampaignPerformanceByProperty`,
    body
  );
  return result;
};

export const ExportCampaignPerformanceExcel = async (body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/Reports/ExportCampaignPerformanceExcel`,
    body
  );
  return result;
};

export const GetCampaignKpiCards = async (body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/Campaigns/GetCampaignKpiCards`,
    body
  );
  return result;
}
